import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path
      d='M9 11.25L11 13.25L15.25 9'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M14.25 3.75H16.5C17.3284 3.75 18 4.42157 18 5.25V19.5C18 20.3284 17.3284 21 16.5 21H7.5C6.67157 21 6 20.3284 6 19.5V5.25C6 4.42157 6.67157 3.75 7.5 3.75H9.75'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M9 3.75C9 2.92157 9.67157 2.25 10.5 2.25H13.5C14.3284 2.25 15 2.92157 15 3.75C15 4.57843 14.3284 5.25 13.5 5.25H10.5C9.67157 5.25 9 4.57843 9 3.75Z'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </>,
  'Compliance'
)
